// extracted by mini-css-extract-plugin
export default {"box":"orderFilterPage_box__guMTR","box__content":"orderFilterPage_box__content__M2HIe","box__content__title":"orderFilterPage_box__content__title__KzfT8"};